import { userInitials } from "./userUtils.js";

export function UserAvatarBanner({ user, c, dark, A }) {
  const isActive = user.status === "active";

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: 12,
        marginBottom: 14,
        padding: 12,
        borderRadius: 10,
        border: `1px solid ${c.cardBdr}`,
        background: c.hover,
      }}
    >
      <div
        style={{
          width: 44,
          height: 44,
          borderRadius: 10,
          background: dark ? `${A}2a` : `${A}18`,
          color: A,
          display: "grid",
          placeItems: "center",
          fontWeight: 700,
          border: `1px solid ${A}55`,
          flexShrink: 0,
        }}
      >
        {userInitials(user.name)}
      </div>
      <div style={{ minWidth: 0, flex: 1 }}>
        <div style={{ fontSize: 16, color: c.text, fontWeight: 700 }}>{user.name}</div>
        <div style={{ fontSize: 12, color: c.sub, marginTop: 2 }}>{user.email}</div>
      </div>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 5,
          background: isActive
            ? (dark ? "rgba(52,211,153,0.12)" : "rgba(16,185,129,0.1)")
            : (dark ? "rgba(255,255,255,0.06)" : "rgba(0,0,0,0.05)"),
          border: `1px solid ${isActive ? "rgba(52,211,153,0.3)" : c.cardBdr}`,
          borderRadius: 20,
          padding: "3px 10px 3px 7px",
          flexShrink: 0,
        }}
      >
        <div
          style={{
            width: 6,
            height: 6,
            borderRadius: "50%",
            background: isActive ? "#34d399" : c.sub,
            boxShadow: isActive ? "0 0 5px #34d39988" : "none",
          }}
        />
        <span
          style={{
            fontSize: 11,
            fontWeight: 600,
            color: isActive ? "#34d399" : c.sub,
            letterSpacing: "0.03em",
            textTransform: "capitalize",
          }}
        >
          {user.status}
        </span>
      </div>
    </div>
  );
}
